import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cybereason = defineConnector({
  identifier: "cybereason",
  name: "Cybereason",
  tagLine: "EDR platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.cybereason\\.net/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.baseUrl}/login.html`,
        formBody: {
          username: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "cookie", name: "JSESSIONID" },
      apply: { kind: "cookie", name: "JSESSIONID" },
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Cybereason console and navigate to **Settings > API Keys** to create an API key.",
        },
      ],
    },
    {
      title: "Enter your Cybereason details",
      items: [
        {
          kind: "url",
          label: "Cybereason server URL",
          required: true,
          placeholder: "https://yourcompany.cybereason.net",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "Your Cybereason console URL.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/rest/system/details`,
  },
  publicEnvVars: ({ baseUrl }) => ({ CYBEREASON_URL: baseUrl || "" }),
});
